export const guestComps = {
  detail: {
    nav: {
      overview: "المعلومات",
      bookings: "الحجوزات",
      checkins: "تسجيلات الدخول",
      invoicing: "الفوترة",
    },
    personalInfo: "المعلومات الشخصية",
    contactInfo: "معلومات الاتصال",
    residenceInfo: "معلومات الإقامة",
    fields: {
      firstName: "الاسم",
      lastName: "اللقب",
      document: "الوثيقة",
      nationality: "الجنسية",
      country: "البلد",
      birthDate: "تاريخ الميلاد",
      email: "البريد الإلكتروني",
      whatsapp: "WhatsApp",
      countryResidence: "بلد الإقامة",
      cityResidence: "مدينة الإقامة",
      relationship: "صلة القرابة",
    },
    cols: {
      code: "الرمز",
      accommodation: "مكان الإقامة",
      checkIn: "تسجيل الدخول",
      checkOut: "تسجيل الخروج",
      status: "الحالة",
      total: "الإجمالي",
      guest: "النزيل",
      booking: "الحجز",
      entryDate: "تاريخ الدخول",
      date: "التاريخ",
    },
    confirmed: "مؤكد",
    fiscalProfile: "الملف الضريبي المسجّل",
    legalName: "الاسم القانوني",
    taxId: "الرقم الضريبي",
    type: "النوع",
    company: "شركة",
    individual: "فرد",
    invoicesIssued: "الفواتير الصادرة",
    empty: {
      bookings: "لا توجد حجوزات مسجّلة لهذا النزيل.",
      checkins: "لا توجد تسجيلات دخول مسجّلة لهذا النزيل.",
      invoices: "لا توجد فواتير صادرة لهذا النزيل.",
    },
    noPdf: "لا يوجد PDF",
    status: {
      sent: "صادرة",
      processing: "قيد المعالجة",
      error: "خطأ",
      pending: "معلّقة",
    },
    close: "إغلاق",
  },
  form: {
    editTitle: "تعديل العميل",
    newTitle: "عميل جديد",
    subtitle: "بيانات الاتصال والفوترة للحجوزات والفواتير القادمة.",
    subtitleEmbedded: "أكمل الملف وستعود إلى الفاتورة دون فقدان الرسوم.",
    backToInvoice: "العودة إلى الفاتورة",
    close: "إغلاق",
    customerTypeAria: "نوع العميل",
    typeIndividual: "فرد",
    typeIndividualHelp: "شخص طبيعي",
    typeCompany: "شركة",
    typeCompanyHelp: "شخص اعتباري",
    identity: "الهوية",
    identityDesc: "المعلومات التي تحدّد مستلم الفاتورة.",
    name: "الاسم",
    namePlaceholder: "محمد",
    lastName: "اللقب",
    lastNamePlaceholder: "أحمد",
    legalName: "الاسم القانوني",
    legalNamePlaceholder: "شركة مثال ذ.م.م.",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "وثيقة ضريبية",
    docPlaceholderIndividual: "بطاقة هوية أو تصريح إقامة أو جواز سفر",
    docType: "نوع الوثيقة",
    select: "اختر",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "جواز سفر",
    docOther: "وثيقة أخرى",
    contact: "الاتصال",
    contactDesc: "قنوات إرسال الفاتورة أو التواصل مع العميل.",
    email: "البريد الإلكتروني",
    emailPlaceholder: "customer@email.com",
    phone: "الهاتف",
    fiscalAddress: "العنوان الضريبي",
    fiscalAddressDesc: "يُستخدم كعنوان المستلم في الفاتورة الكاملة.",
    country: "البلد",
    address: "العنوان",
    addressPlaceholder: "الشارع والرقم والطابق",
    city: "المدينة",
    cityPlaceholder: "مدريد",
    state: "المحافظة / الولاية",
    postalCode: "الرمز البريدي",
    postalPlaceholder: "28001",
    requiredNote: "* الحقول المطلوبة للملف الضريبي",
    backToInvoiceShort: "العودة إلى الفاتورة",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveChanges: "حفظ التغييرات",
    createClient: "إنشاء عميل",
    err: {
      name: "أدخل الاسم.",
      lastName: "أدخل اللقب.",
      legalName: "أدخل الاسم القانوني.",
      taxId: "التعريف الضريبي إلزامي للشركات.",
      country: "اختر البلد.",
      address: "أدخل العنوان الضريبي.",
      city: "أدخل المدينة.",
      postalCode: "أدخل الرمز البريدي.",
      email: "أدخل بريدًا إلكترونيًا صالحًا.",
      saveFailed: "تعذّر حفظ العميل.",
    },
  },
  list: {
    title: "عملاء الفوترة",
    subtitle: "ملفات ضريبية قابلة لإعادة الاستخدام لإصدار الفواتير ومراجعتها",
    searchLabel: "البحث عن العملاء",
    searchPlaceholder: "الاسم أو البريد الإلكتروني أو الهاتف أو الوثيقة…",
    clearSearch: "مسح البحث",
    exporting: "جارٍ التصدير...",
    exportClients: "تصدير العملاء",
    newClient: "عميل جديد",
    cols: {
      fiscalClient: "العميل الضريبي",
      contact: "الاتصال",
      fiscalDocument: "الوثيقة الضريبية",
      country: "البلد",
      linkedBookings: "الحجوزات المرتبطة",
      invoices: "الفواتير",
      actions: "الإجراءات",
    },
    company: "شركة",
    individual: "فرد",
    noEmail: "لا يوجد بريد إلكتروني",
    noPhone: "لا يوجد هاتف",
    viewInvoicesTitle: "عرض {count} فاتورة لهذا النزيل | عرض {count} فواتير لهذا النزيل",
    invoicesCount: "{count} فاتورة | {count} فواتير",
    noInvoices: "لا توجد فواتير",
    editClient: "تعديل العميل",
    edit: "تعديل",
    viewDetail: "عرض التفاصيل",
    view: "عرض",
    emptySearchTitle: "لم نعثر على ملفات ضريبية",
    emptySearchSub: "لا يوجد عملاء فوترة يطابقون “{term}”.",
    emptyTitle: "لا يوجد عملاء فوترة بعد",
    emptySub: "أنشئ ملفًا ضريبيًا عند إصدار فاتورة أو احفظه الآن لإعادة استخدامه لاحقًا.",
    createFirst: "إنشاء أول عميل",
    selectedClient: "العميل المحدد",
  },
  internalName: {
    addBtn: "اسم داخلي",
    title: "الاسم الداخلي",
    hint: "أنت وحدك من تراه. يظهر قبل الاسم العام في قوائمك وتقاويمك.",
    removeWarn: "سيُزال من قوائمك. لن تشير رسائل رموز الدخول ولا الوكيل الذكي بعد الآن إلى مكان الإقامة المقصود.",
    edit: "تعديل",
    cancel: "إلغاء",
    removing: "جارٍ الإزالة…",
    confirmRemove: "نعم، أزِل",
    remove: "إزالة",
    editTitle: "تعديل الاسم الداخلي",
    addTitle: "إضافة اسم داخلي",
    eyebrow: "الاسم الداخلي لمكان الإقامة",
    modalHint: "اسم خاص لتتعرّف على مكان الإقامة بنظرة واحدة (مثل «شقة روزر» أو «الثاني»). لا يراه نزلاؤك أبدًا.",
    placeholder: "شقة روزر",
    previewLabel: "ستراه هكذا",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
    saveFailed: "تعذّر حفظ الاسم الداخلي.",
  },
};
